/** @jsx jsx */
// eslint-disable-next-line
import React, { Component } from 'react'
import { css, jsx } from '@emotion/core'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Formik } from 'formik'
import { theme } from '../../../constants'

const styles = {}
styles.form = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  width: 100%;
`
styles.buttonStyle = {
  background: theme.palette.primary.main,
  color: 'white',
  borderRadius: '8px',
  width: '400px',
  height: '43px'
}

const CssTextField = withStyles({
  color: 'white',
  root: {
    '& label.Mui-focused': {
      color: 'white'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: `${theme.palette.primary.main} !important`
    },
    '& .Mui-disabled': {
      color: `${theme.palette.primary.main} !important`
    },
    '& .MuiOutlinedInput-input': {
      color: 'white'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: `${theme.palette.primary.main} !important`,
        borderRadius: '8px',
        width: '400px'
      }
    },
    '& .MuiOutlinedInput-adornedEnd': {
      borderRadius: '8px',
      paddingRight: '0px'
    }
  }
})(TextField)

const inputPropsEmail = { autoComplete: 'new-email' }

class ForgotForm extends Component {
  formInitialValues = { email: '' }

  validateForm = values => {
    const errors = {}
    if (!values.email) {
      errors.email = window.I18n.t('common.required')
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = window.I18n.t('login.invalidEmail')
    }
    return errors
  }

  render() {
    return (
      <Formik
        initialValues={this.formInitialValues}
        validate={this.validateForm}
        onSubmit={this.props.onSubmit}
      >
        {formik => (
          <form css={styles.form} noValidate onSubmit={formik.handleSubmit} method="POST">
            <CssTextField
              fullWidth
              label={window.I18n.t('login.enterYourEmail')}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              type="email"
              name="email"
              inputProps={inputPropsEmail}
              variant="outlined"
              error={formik.errors.email && formik.touched.email && !!formik.errors.email}
              helperText={formik.errors.email && formik.touched.email && formik.errors.email}
            />
            <Button
              variant="contained"
              fullWidth
              disabled={formik.isSubmitting}
              style={styles.buttonStyle}
              type="submit"
            >
              {formik.isSubmitting ? (
                <CircularProgress color="inherit" size={24} thickness={4} />
              ) : (
                <span>{window.I18n.t('common.reset')}</span>
              )}
            </Button>
          </form>
        )}
      </Formik>
    )
  }
}

ForgotForm.propTypes = {
  onSubmit: PropTypes.func.isRequired
}

export default ForgotForm
